import { render } from "./finco.vue?vue&type=template&id=7f3e944c&scoped=true"
import script from "./finco.vue?vue&type=script&lang=js"
export * from "./finco.vue?vue&type=script&lang=js"

import "./finco.vue?vue&type=style&index=0&id=7f3e944c&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3e944c"]])

export default __exports__